import { render, staticRenderFns } from "./benefitList.vue?vue&type=template&id=7587e7ec&scoped=true&"
import script from "./benefitList.vue?vue&type=script&lang=js&"
export * from "./benefitList.vue?vue&type=script&lang=js&"
import style0 from "./benefitList.vue?vue&type=style&index=0&id=7587e7ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7587e7ec",
  null
  
)

export default component.exports